import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import moment from "moment";

class ClutchReport {
  constructor() {
    this.finalData = null;
    this.schema = null;
    this.selectedVehicle = null;
    this.startTime = null;
    this.endTime = null;
    this.hour = 1000 * 60 * 60;
    this.bucketSize = this.hour;

    // Bind methods
    this.getHistory = this.getHistory.bind(this);
    this.getLiability = this.getLiability.bind(this);
    this.drawGraph = this.drawGraph.bind(this);
    this.drawRatingDistribution = this.drawRatingDistribution.bind(this);
    this.processDownloadData = this.processDownloadData.bind(this);
    this.graphZoomListener = this.graphZoomListener.bind(this);

    // Initialize graph listener
    setTimeout(() => {
      window.addInGraph2Listener(
        "zoom",
        "ratings",
        this.graphZoomListener,
        "ratingsReport"
      );
    }, 500);
  }

  processData(resp, vehicleMap, callback) {
    callback(resp);
  }

  getHistory(schema, data, store, drawMain) {
    console.log(schema,this.schema)
    this.finalData = null;
    let saveState = null;
    let tableStateData = null;
    this.selectedVehicle = (window.selectedVehicles[0] || {}).data;

    if (data.vehicle && data.vehicle.length) {
      if (window.setReportWindowTabBusy) {
        window.setReportWindowTabBusy(schema, true);
      }

      const handleSuccess = (resp) => {
        if (window.setReportWindowTabBusy) {
          window.setReportWindowTabBusy(schema, false);
        }

        this.processData(resp, store.vehicleMap, (data) => {
          this.finalData = data;
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          if (schema.content[3].ref) {
            schema.content[3].ref.setData(data);
          }
        });
        this.drawGraph(schema, data, drawMain);
      };

      if (schema.content[3].ref) {
        schema.content[0].ref.setBusy(true);
        schema.content[1].ref.setBusy(true);
        schema.content[3].ref.setBusy(true);
        saveState = schema.content[3].ref.props.saveState;
        tableStateData = [
          schema.content[3].ref.state,
          schema.content[3].ref.props.schemaKey,
          schema.content[3].ref.props.data,
        ];
      }

      const body = {
        vehicleid: [this.selectedVehicle.vehicleid],
        vehicleno: [this.selectedVehicle.vehicleno],
        starttime: data.starttime.unix() * 1000,
        endtime: data.endtime.unix() * 1000,
      };

      if (window.showNoGpsFixData === true) {
        body.fixqfilter = false;
      }

      this.startTime = body.starttime;
      this.endTime = body.endtime;

      ReportAPIs.clutchUsageReport(body).then(handleSuccess, () =>
        handleSuccess([])
      );
    } else {
      console.log("Please select at least one vehicle");
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Please select a vehicle",
          content: "Please select a vehicle",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }
    this.getLiability(schema, data, store);
  }

  getLiability(schema, data, store) {
    schema.content[2].ref.setBusy(true);

    const handleSuccess = (resp) => {
      if (resp.length) {
        schema.content[2].ref.setData(resp[0].liability);
        schema.content[2].ref.setBusy(false);
      }
    };

    const body = {
      vehicleid: [this.selectedVehicle.vehicleid],
      vehicleno: [this.selectedVehicle.vehicleno],
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };

    ReportAPIs.clutchLiabilityReport(body).then(handleSuccess);
  }

  drawGraph(schema, data, drawMain = true) {
    if (drawMain && schema.content[0].ref) {
      schema.content[0].ref.setBusy(false);
      let max = 0;
      for (let idx in this.finalData) {
        if (this.finalData[idx].score > max) max = this.finalData[idx].score;
      }

      schema.content[0].ref.draw(
        {
          priority: 0,
          data: [
            this.finalData.map((t) => ({ value: t.score, time: t.starttime })),
          ],
          reqTime: Date.now(),
          axis: 0,
        },
        {
          xDomainValue: [this.startTime, this.endTime],
          yDomainValue: [0, parseInt(max * 1.5)],
          shapes: [
            {
              strokeOpacity: 0.3,
              strokeWidth: "1px",
              stroke: "#000",
              axis: 0,
              type: "path",
              data: [
                { time: data.starttime, value: 6 },
                { time: data.endtime, value: 6 },
              ],
            },
          ],
        }
      );
    }
    this.drawRatingDistribution(this.finalData);
  }

  drawRatingDistribution(data) {
    if (this.schema.content[1].ref) {
      this.schema.content[1].ref.setBusy(false);
      const filtr = (t) => data.filter((i) => i.score == t).length || 0;

      this.schema.content[1].ref.setData({
        data: [
          {
            name: "0 :",
            color: "#c52466",
            overlayColor: "#c52466",
            value: filtr(1),
          },
          {
            name: "1 :",
            color: "#d93c57",
            overlayColor: "#ffffbf",
            value: filtr(1),
          },
          {
            name: "2 :",
            color: "#e66e5b",
            overlayColor: "#e66e5b",
            value: filtr(2),
          },
          {
            name: "3 :",
            color: "#f7ab5b",
            overlayColor: "#f7ab5b",
            value: filtr(3),
          },
          {
            name: "4 :",
            color: "#fdde87",
            overlayColor: "#fdde87",
            value: filtr(4),
          },
          {
            name: "5 :",
            color: "#ffffbf",
            overlayColor: "#ffffbf",
            value: filtr(5),
          },
        ],
        unit: "Score",
        name: "Score Distribution",
      });
    }
  }

  processDownloadData(data) {
    let arr = [];
    if (this.selectedVehicle) {
      arr = [
        { c1: "Vehicle No", c2: this.selectedVehicle.vehicleno },
        {
          c1: "Vehicle Model",
          c2: this.selectedVehicle.vehiclemeta
            ? this.selectedVehicle.vehiclemeta.model
            : null || this.selectedVehicle.vehicleModel
            ? this.selectedVehicle.vehicleModel.model
            : "",
        },
        { c1: "Start Time", c2: moment(this.startTime).format(dateFormat) },
        { c1: "End Time", c2: moment(this.endTime).format(dateFormat) },
        { c1: "", c2: "" },
        { c1: "", c2: "" },
        { c1: "Start Time", c2: "End Time", c3: "Score" },
      ];
    } else {
      console.log("Selected Vehicle not found");
    }

    return [
      ...arr,
      ...data.map((i) => ({
        c1: i.starttime__processed__,
        c2: i.endtime__processed__,
        c3: i.score,
      })),
    ];
  }

  graphZoomListener(event) {
    const getData = () => {
      let data = {};
      let tool;
      for (let idx in this.schema.toolbar) {
        tool = this.schema.toolbar[idx];
        if (tool.ref && tool.ref.getData) {
          data[tool.key] = tool.ref.getData();
        } else if (tool.ref && "value" in tool.ref) {
          data[tool.key] = tool.ref.value;
        }
      }
      return data;
    };

    try {
      this.schema.toolbar[1].ref.setData(event.xDomainValue[0]);
      this.schema.toolbar[2].ref.setData(event.xDomainValue[1]);
      const data = getData();
      this.getLiability(this.schema, data);
      const starttime = data.starttime.unix() * 1000;
      const endtime = data.endtime.unix() * 1000;
      const fData = this.finalData.filter(
        (f) => f.starttime >= starttime && f.endtime <= endtime
      );

      if (this.schema.content[3].ref) {
        this.schema.content[3].ref.setData(fData);
      }
      this.drawRatingDistribution(fData);
    } catch (e) {
      console.error("Error in graphZoomListener:", e);
    }
  }

  createSchema() {
    this.schema = {
      key: "clutch_report",
      name: "Clutch",
      toolbar: [
        {
          key: "vehicle",
          type: schemaTypes.MULTI_SELECT,
          singleSelect: true,
          storeData: (state) => ({
            data: (() => {
              let newMap = {};
              for (let idx in state.vehicleMap) {
                if (idx.indexOf("user") === -1) {
                  newMap[idx] = state.vehicleMap[idx];
                }
              }
              return newMap;
            })(),
            name: "vehicleno",
            id: "vehicleid",
          }),
          onItemChange: (v) => window.saveVehicleState(v),
          defaultValue: () => ({
            data: window.selectedVehicles.map((i) => i.id),
            updatedAt: window.selectedVehiclesUpdatedAt,
          }),
        },
        {
          key: "starttime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "Start Date",
          model: Date.now() - 1000 * 60 * 60 * 24,
        },
        {
          key: "endtime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "End Date",
        },
        {
          key: "get_history",
          type: schemaTypes.BUTTON,
          name: "Get Clutch Report",
          onClick: this.getHistory,
        },
        {
          key: "download",
          type: schemaTypes.BUTTON,
          iconType: "class",
          icon: "fa fa-download",
          onClick: () => {
            if (this.finalData) {
              JSONToCSVConvertor(
                this.processDownloadData(this.finalData),
                "ViewReport",
                false,
                false
              );
            }
          },
        },
      ],
      content: [
        {
          key: "ratings",
          type: schemaTypes.IN_GRAPH,
          graphType: "graph",
          graphSetName: "ratingsReport",
          position: { width: 6, height: 4, left: 0, top: 0 },
          pointerTime: true,
          ticks: 5,
          dots: true,
          config: [
            { listenTo: [{ key: "value" }], color: "#d88d42", name: "Score" },
          ],
        },
        {
          key: "distribution",
          name: "Rating Distribution",
          type: schemaTypes.IN_PIE_CHART,
          graphType: "graph",
          graphSetName: "ratingDistribution",
          hideinfo: true,
          percent: true,
          position: { width: 6, height: 4, left: 0, top: 4 },
        },
        {
          key: "liability",
          type: schemaTypes.INFO,
          position: { width: 6, height: 4, left: 0, top: 8 },
        },
        {
          key: "dataTable",
          type: schemaTypes.IN_TABLE,
          position: { width: 6, height: 12, left: 6, top: 0 },
          head: [
            {
              key: "starttime",
              name: "Start Time",
              type: "DATE",
              format: dateFormat,
            },
            {
              key: "endtime",
              name: "End Time",
              type: "DATE",
              format: dateFormat,
            },
            { key: "score", name: "Score" },
          ],
        },
      ],
    };
    return this.schema;
  }
}

// Create instance and export schema
const clutchReportInstance = new ClutchReport();
export default clutchReportInstance.createSchema();
